import { call, put, select, takeLatest } from '@redux-saga/core/effects';
import * as types from '../../actions/shopList/shopListActionTypes';
import * as actions from '../../actions/shopList/shopListActions';
import { ShopListState } from '../../reducers/shopList/shopListReducer';
import reservationService from '../../services/reservationService';

function* getClubOptionsListSaga(): Generator<unknown> {
  try {
    const response: any = yield call(reservationService().getClubOptions);
    if (response.data.result === 0) {
      const { region_list, tag_list } = response.data;
      const areaOptions = region_list
        .filter((region: any) => region.region_id !== 999)
        .map((region: any) => ({
          id: region.region_id.toString(),
          name: region.region_name,
        }));
      const facilityOptions = tag_list
        .filter((tag: any) => tag.tag_manage === 1)
        .sort((a: any, b: any) => a.order_no - b.order_no)
        .map((tag: any) => ({
          id: tag.tag_id.toString(),
          name: tag.tag_name,
          icon: tag.thumbnail_image,
        }));

      const serviceOptions = tag_list
        .filter((tag: any) => tag.tag_manage === 2)
        .sort((a: any, b: any) => a.order_no - b.order_no)
        .map((tag: any) => ({
          id: tag.tag_id.toString(),
          name: tag.tag_name,
          icon: tag.thumbnail_image,
        }));

      yield put(actions.getVisitorClubOptionsListSuccess(areaOptions, facilityOptions, serviceOptions));
    } else {
      throw new Error('API returned error result');
    }
  } catch (error: any) {
    yield put(actions.getVisitorClubOptionsListFailure(error.message || '絞り込み条件の取得に失敗しました'));
  }
}

function* fetchShopsSaga(): Generator<unknown> {
  try {
    const state = (yield select()) as { shopList: ShopListState };
    const { searchParams, filters } = state.shopList;

    // 构建请求参数
    const requestParams: any = {};

    // 添加区域筛选
    if (searchParams.area) {
      requestParams.region_code = parseInt(searchParams.area, 10);
    }

    // 添加关键字搜索
    if (searchParams.keyword) {
      requestParams.club_name_or_address = searchParams.keyword;
    }

    // 添加标签筛选（设施和服务合并）
    const tagIds = [...filters.facilities, ...filters.services].map((id) => parseInt(id, 10));
    if (tagIds.length > 0) {
      requestParams.tag_list = tagIds;
    }

    // 调用API获取店铺列表
    const response: any = yield call(reservationService().searchClubs, requestParams);
    console.log(response);
    if (response.data.result === 0) {
      // 转换店铺数据格式
      const clubList = response.data.club_list || [];
      const shops = clubList.map((club: any) => ({
        id: club.club_id.toString(),
        name: club.club_name,
        image: club.club_picture || '/assets/img/map-pin-image@2x.png',
        businessHours: club.open_date,
        phone: club.telephone,
        address: `${club.post_id ? `〒${club.post_id}` : ''} ${club.address}${
          club.addr_buildname ? ` ${club.addr_buildname}` : ''
        }`,
        annexOpenDate: club.annex_flag ? club.annex_open_date : '',
        annexAddress:
          club.annex_flag &&
          `${club.annex_post_id ? `〒${club.annex_post_id}` : ''}
          ${club.annex_address ? ` ${club.annex_address}` : ''}
          ${club.annex_addr_buildname ? ` ${club.annex_addr_buildname}` : ''}`,
        features: (club.tag_list || []).map((tag: any) => ({
          id: tag.tag_id.toString(),
          name: tag.tag_name,
          icon: tag.thumbnail_image || '/assets/img/default-icon',
          category: 'facility' as const, // 根据 tag_manage 区分 facility/service
        })),
        isBookmarked: false,
        latitude: parseFloat(club.latitude),
        longitude: parseFloat(club.longitude),
        preOpenDay: club.pre_open_day,
      }));
      yield put(actions.fetchShopsSuccess(shops, response.data.total || 0));
    } else {
      throw new Error('API returned error result');
    }
  } catch (error: any) {
    yield put(actions.fetchShopsFailure(error.message || '店铺情報の取得に失敗しました'));
  }
}

// 根Saga
export function* shopListSaga(): Generator<unknown> {
  yield takeLatest(types.GET_VISITOR_CLUB_OPTIONS_LIST_REQUEST, getClubOptionsListSaga);
  yield takeLatest(types.GET_VISITOR_CLUB_LIST_REQUEST, fetchShopsSaga);
}

export default shopListSaga;
